<app-rightimagepagewrapper [src]="loginImageSrc">
  <app-title [title]="'generic.welcome_back' | translate"></app-title>
  @if (error) {
    <app-banner
      title="Login Error"
      [description]="'The email address or password is incorrect. Please try again!'"
      (dismissclick)="clearError()"
    ></app-banner>
  }
  @if (activeTenant()?.emailandpassword) {
    <form class="form" [formGroup]="form" (ngSubmit)="onSubmit(form)">
      <div class="input-group">
        <app-input
          name="email"
          formControlName="email"
          [label]="
            (providerParam() === 'cruftsclub' ? 'generic.crufts_club_membership_email' : 'generic.email_address')
              | translate
          "
          [placeholder]="'generic.enter_email' | translate"
          [span]="6"
        ></app-input>
      </div>
      <div>
        <div class="input-group">
          <app-input
            name="password"
            formControlName="password"
            [label]="'generic.password' | translate"
            type="{{ showPassword ? 'text' : 'password' }}"
            [placeholder]="'generic.enter_password' | translate"
            [span]="6"
          >
            <button
              (click)="togglePasswordVisibility()"
              type="button"
              class="absolute inset-y-0 right-0 flex items-center pr-3"
            >
              <svg [lucideIcon]="showPassword ? EyeIcon : EyeOffIcon" [size]="24" [class]="'dark:text-ds-text-base'" />
            </button>
          </app-input>
        </div>
        <div>
          <app-righttextbutton linktext="Forgotten Password?" (linkclick)="forgottenpassword()"></app-righttextbutton>
        </div>
      </div>
      <app-form-submission-button
        [form]="form"
        [loading]="loading"
        [buttonText]="'generic.login' | translate"
      ></app-form-submission-button>
    </form>
  }
  @if (activeTenant()?.google) {
    <button class="google-btn w-full mt-3" (click)="google()">
      @if (!loading) {
        <span>Continue With Google</span>
      }
      @if (loading) {
        <span>loading...</span>
      }
    </button>
  }
  @if (providerswitcher) {
    <div class="mt-3">
      <app-centertextbutton
        [text]="'Not with ' + (activeTenant()?.name ?? '') + '?'"
        [linktext]="
          environment.typeOfClient === 'business' ? 'Choose a different business' : 'Insured with one of our partners'
        "
        (linkclick)="anothertenant()"
      ></app-centertextbutton>
    </div>
  }
  @if (activeTenant()?.allowCreation) {
    <div class="flex items-center justify-center mt-10">
      <div class="w-full h-[1px] bg-gray-300"></div>
      <div class="mx-4 text-gray-500">Or</div>
      <div class="w-full h-[1px] bg-gray-300"></div>
    </div>
    <div class="mt-10">
      <app-centertextbutton
        [text]="'New to Joii?'"
        linktext="Create an account here"
        (linkclick)="register()"
      ></app-centertextbutton>
    </div>
  }
</app-rightimagepagewrapper>
